import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

const APP_NAME = 'Olive Admin';

/**
 * Define o título da aba a partir da propriedade `title` das rotas, no formato
 * "<Página> · Olive Admin".
 *
 * A parte variável vem primeiro porque a aba corta o texto pelo fim e o leitor de tela
 * anuncia o começo. Rotas sem `title` herdam o da rota pai mais próxima (buildTitle pega
 * o mais profundo que existir); sem nenhum, a aba mostra só o nome do app.
 */
@Injectable({ providedIn: 'root' })
export class AppTitleStrategy extends TitleStrategy {
  constructor(private readonly title: Title) {
    super();
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const pageTitle = this.buildTitle(snapshot);

    this.title.setTitle(pageTitle ? `${pageTitle} · ${APP_NAME}` : APP_NAME);
  }
}
